// src/autoPageView.js — generic fallback view for a PAGE payload (kind:"page"), used when no authored page
// view is registered. Renders a reasonable marketing page from the demo descriptor: a hero, a launch CTA, a
// screenshot gallery, a login card, and dashboard embeds. Mirrors autoListView.js in shape.

export function createAutoPageView(html, C) {
  const { Hero, Section, Gallery, LoginCard, DashboardEmbed, CTA } = C;

  return function autoPageView(d) {
    const demo = d.demo || {};
    const assets = d.assets || [];
    const dashboards = d.dashboards || [];

    // Screenshot gallery: map each asset descriptor to its inlined data-URI (dropped when the byte is missing).
    const shots = assets
      .map((a) => ({ url: d.asset(a && a.name), fileName: (a && (a.description || a.name)) || '', type: 'image' }))
      .filter((it) => it.url);

    // The page shell is full-bleed (padding:0). Hero + CTA span the viewport; the rest sits in a centered
    // inner container (.aq-page-in) so the fallback reads as a landing page, not an edge-to-edge document.
    return html`<div class="aq-doc aq-page">
      <div class="aq-page-in" style="padding-top:16px">
        <${Hero} title=${demo.name || 'Demo'} subtitle=${demo.description || ''} meta=${{}} />

        ${demo.launchUrl ? html`<${CTA} href=${demo.launchUrl} label="Launch demo ↗" />` : null}

        ${shots.length
          ? html`<${Section} title="Screenshots"><${Gallery} items=${shots} /><//>`
          : null}

        ${demo.loginEmail || demo.loginPassword
          ? html`<${Section} title="Try it yourself">
              <${LoginCard} email=${demo.loginEmail} password=${demo.loginPassword}
                note=${demo.slug ? `Demo: ${demo.slug}` : null} />
            <//>`
          : null}

        ${dashboards.length
          ? html`<${Section} title="Live dashboards">
              ${dashboards.map(
                (db, i) => html`<${DashboardEmbed} key=${i} token=${db && db.token} url=${db && db.url} title=${db && db.title} />`
              )}
            <//>`
          : null}
      </div>
    </div>`;
  };
}

export default createAutoPageView;
